<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from 'src/components/Dashboard/Layout/TopNavbar.vue'
  import ContentFooter from 'src/components/Dashboard/Layout//ContentFooter.vue'
  import DashboardContent from 'src/components/Dashboard/Layout//Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    computed: {
      ...mapState({
        currentEventInfo: state => state.events.currentEventInfo,
      }),
      // ...mapGetters({currentEventInfo: 'events/currentEventInfo'}),
      ...mapActions({changeEventByUri: 'events/changeEventByUri'})
    },
    beforeRouteEnter (to, from, next) {
      // вызывается до подтверждения пути, соответствующего этому компоненту.
      // НЕ ИМЕЕТ доступа к контексту экземпляра компонента `this`,
      // так как к моменту вызова экземпляр ещё не создан!
      // console.log("Event route beforeRouteEnter:event-root")
      next(vm => {
        if (from === null || from.params === null || from.params.eventUri !== to.params.eventUri) {
          vm.$store.dispatch('events/changeEventByUri', to.params.eventUri)
        }
      })

    },
    beforeRouteUpdate (to, from, next) {
      // вызывается когда маршрут, что рендерит этот компонент изменился,
      // но этот компонент будет повторно использован в новом маршруте.
      // Например, для маршрута с динамическими параметрами `/foo/:id`, когда мы
      // перемещаемся между `/foo/1` и `/foo/2`, экземпляр того же компонента `Foo`
      // будет использован повторно, и этот хук будет вызван когда это случится.
      // Также имеется доступ в `this` к экземпляру компонента.
      // console.log("Event route beforeRouteUpdate:event-root")
      if (from === null || from.params === null || from.params.eventUri !== to.params.eventUri) {
        this.$store.dispatch('events/changeEventByUri', to.params.eventUri)
      }
      next()
    },
    breadcrumb ()  {
      return {
        label: this.currentEventInfo ? this.currentEventInfo.name : "Главная",
      }},
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
    },
    data () {
      return {
      }
    }
  }

</script>
